import * as React from 'react'
import { Fun } from 'widgets-for-react'
import { PostMessage } from './iframe.state'
import { HeightMessage } from './iframe.utils'

export type IframeProps = {
  title: string
  url: string
  embedCode: string
  height?: number
  loading: 'lazy' | 'eager'
  onLoaded: Fun<void, void>
  messageOrigin?: string
  handlePostMessage?: (m: PostMessage) => void
}

type IframeState = {
  width: string
  status: 'loading' | 'done'
  height?: number
}

export class Iframe extends React.Component<IframeProps, IframeState> {
  private iframe: React.RefObject<HTMLIFrameElement> | null = null

  constructor(props: IframeProps) {
    super(props)

    this.iframe = React.createRef()

    this.state = {
      width: '100%',
      status: 'loading'
    }

    this.handleIFrameLoad = this.handleIFrameLoad.bind(this)
    this.handlePostMessage = this.handlePostMessage.bind(this)
  }

  componentDidMount() {
    window.addEventListener('message', this.handlePostMessage)
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handlePostMessage)
  }

  handleIFrameLoad() {
    if (this.iframe) {
      this.setState((s) => ({ ...s, status: 'done' }))
      this.iframe?.current?.contentWindow?.postMessage('[iFrameSizer]:init:true', '*')
    }

    let resizeIFrameToFitContent = (iFrame: HTMLElement | null) => {
      // iFrame.width = iFrame.contentWindow.document.body.scrollWidth;
      let height = this.state.height;
      try {
        // @ts-ignore
        height = iFrame?.contentWindow?.document?.body?.scrollHeight
      } catch (e) {}
      if (height == undefined) {
        height = iFrame ? (iFrame.offsetWidth / 16) * 9 : 500
      }
      // this.setState({ ...this.state, height: height })
    }

    let tryResize = () => {
      var iFrame = document.getElementById('iframe')
      if (iFrame == undefined || iFrame == null) {
        setTimeout(tryResize, 100)
      } else {
        resizeIFrameToFitContent(iFrame)
      }
    }

    tryResize()
  }

  handlePostMessage(m: MessageEvent) {
    // Verify origin of message
    if (m.origin && m.origin !== this.props.messageOrigin) return
    // Make sure that the handled postMessage has a type field.
    if (!m.data.hasOwnProperty("type")) return;
    const data: PostMessage = m.data
    if (data.type == "heightCalculation") {
      const heightData = data as HeightMessage
      this.setState({ ...this.state, height: heightData.height })
    } else if (this.props.handlePostMessage) {
      this.props.handlePostMessage(data)
    } else {
      console.warn(`No handler created for postMessage event: ${m.data}`)
    }
  }

  render() {
    return (
      <>
        {this.props.url != '' && this.state.status === 'loading' && (
          <p className="iframe-loading">Content is loading...</p>
        )}

        <iframe
          ref={this.iframe}
          id="iframe"
          src={this.props.url != '' ? this.props.url : ''}
          onLoad={this.handleIFrameLoad}
          seamless={true}
          srcDoc={this.props.embedCode != '' ? this.props.embedCode : ''}
          className="block__iframe"
          title={this.props.title}
          loading={this.props.loading}
          {...this.state}
          height={this.props.height ?? this.state.height}
        ></iframe>
      </>
    )
  }
}
